import React from 'react';

export default function NotFound() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center max-w-md px-4">
        <h1 className="text-6xl font-bold text-gray-200 mb-4">404</h1>
        <h2 className="text-xl font-semibold text-gray-900 mb-2">Dashboard not found</h2>
        <p className="text-gray-500 mb-6">
          This client dashboard doesn't exist. Please check the URL provided by your account manager.
        </p>
        <a
          href="mailto:chris@beechppc.com"
          className="inline-block px-6 py-2.5 bg-gray-900 text-white rounded-lg text-sm font-medium hover:bg-gray-800 transition-colors"
        >
          Contact support
        </a>
      </div>
    </div>
  );
}
